import logUtil from 'utils/log'
import getQueryParamsFromStringObjectUtil from 'utils/object/get-query-params-from-string'
import getSearchLocationUtil from 'utils/location/get-search'

const REFERRAL_CODE_LENGTH = 6

export default function getReferralCodeFromLocationLoyaltyUtil () {
  const search = getSearchLocationUtil()
  const queryParams = getQueryParamsFromStringObjectUtil(search || '')
  const referralCode = queryParams.referral_code
  // const debugProps = {
  //   search,
  //   queryParams,
  //   referralCode
  // }

  // logUtil('getReferralCodeFromLocationLoyaltyUtil').debug('[noop] debugProps=', debugProps)
  if (referralCode?.length !== REFERRAL_CODE_LENGTH) {
    logUtil('getReferralCodeFromLocationLoyaltyUtil').debug(`[noop] invalid referralCode=${referralCode}`)
    return
  }

  return referralCode
}
